import * as React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import LogoutBtn from "../LogoutBtn";

const styles = require("./styles.module.scss");

interface IModalFooterProps {
  onCancelClick?: () => void;
  onSaveClick?: (ev) => void;
  children?: any;
}

const ModalFooter: React.SFC<IModalFooterProps> = props => (
  <Modal.Footer className={styles.footer}>
    <Row>
      <Col md={6} mdOffset={3}>
        <Button onClick={props.onCancelClick}>Cancel</Button>
        <Button onClick={props.onSaveClick}>Continue</Button>
      </Col>
    </Row>
  </Modal.Footer>
);

export default ModalFooter;
